import { PUBLIC_BONUS_TRACKER_VIEW } from './types';

export const triggerPublicBonusTrackerIsViewed = (bonusId) => ({
  type: PUBLIC_BONUS_TRACKER_VIEW,
  bonusId,
});
